export const FeedModels = Object.freeze({
  ACKNOWLEDGEMENT: 'Acknowledgement',
  DOCUMENT: 'Document',
  TERMINATION: 'Termination',
});

export default {
  FeedModels,
};
